export default {
    buttonText: "Subscribe"
};
